import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import React, { useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
	ICreateSubcategoryModalContext,
	CreateSubcategoryModalContext,
} from '../../../../../../../../../createSubcategoryModalContext/createSubcategoryModalState/createSubcategoryModalContext';
import { IGetCategoriesShort, IGetCategoriesShortResponse } from 'types';
import { getCategoriesShortInfo } from 'backend/categories';
import { useFetchData } from 'hooks/useFetchData';

const CategorySelect: React.FC = () => {
	const { setIDSelectedCategory, IDRestaurant } =
		useContext<ICreateSubcategoryModalContext>(CreateSubcategoryModalContext);
	const { response, loading, refetch, responseError } = useFetchData<
		IGetCategoriesShortResponse,
		IGetCategoriesShort
	>(IDRestaurant ? getCategoriesShortInfo : null, {
		restaurantIds: [IDRestaurant || ''],
	});
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectCategory') }], [t]);

	useEffect(() => {
		refetch();
	}, [IDRestaurant]);

	return (
		<FormSelect
			name="IDSelectedCategory"
			label="categoryLabel"
			options={response?.data.categories}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setIDSelectedCategory}
			validationRules={validationRules}
		/>
	);
};

export default CategorySelect;
